import $ from 'cash-dom';

const Accordion = {
	init() {
        let self = this;

        self._openAllActivePanels();

        $(document).on('click', '.accordion-container .accordion-title', function (e) {
            e.preventDefault();

            //TODO: why holdOpen has reverse logic? find out later with PM
            const $accordionContainer = $(e.target).closest('.accordion-container'),
                $accordion = $(e.target).closest('.accordion'),
                $panel = $accordion.find('.panel'),
                $holdOpen = !!$accordionContainer.data('hold-open');

            if (!$panel.length) {
                return;
            }

            if ($holdOpen) {
                self._handleHoldOpenPanelClick($accordion, $panel);
            } else {
                $accordionContainer.find('.accordion.active').removeClass('active');
                $accordion.addClass('active');

                self._closeAllPanels($accordionContainer);
                self._togglePanel($panel.get(0));
            }
        });

		$(document).on('accordion-open-active-panel', () => {
            self._openAllActivePanels();
		});
	},

	_handleHoldOpenPanelClick($accordion, $panel) {
		if ($accordion.hasClass('active')) {
			$accordion.removeClass('active');
		} else {
            let $accordionContainer = $accordion.closest('.accordion-container');

            $accordionContainer.find('.active').removeClass('active');
			this._closeAllPanels($accordionContainer);
			$accordion.addClass('active');
		}

		this._togglePanel($panel.get(0));
	},

	_openAllActivePanels() {
        let self = this;

		$('.accordion-container').find('.accordion').each((i, accordion) => {
			const $accordion = $(accordion);

			if ($accordion.hasClass('active')) {
				const $panel = $accordion.find('.panel');
                self._openPanel($panel.get(0));
			}
		});
	},

	_closeAllPanels($accordionConatainer) {
        let self = this;

        $accordionConatainer.find('.accordion .panel').each((i, panel) => {
            self._closePanel(panel);
		});
	},

	_togglePanel(panel) {
		if (!panel) {
			return;
		}

		if (panel.style.maxHeight) {
			this._closePanel(panel);
		} else {
			this._openPanel(panel);
		}
	},

	_closePanel(panel) {
		panel.style.maxHeight = null;
	},

	_openPanel(panel) {
		panel.style.maxHeight = panel.scrollHeight + "px";
	},
}

export default Accordion;

$(function () {
    Accordion.init();
});
